import { gql } from "@apollo/client";

export const GET_CODE_SECURITY_SUMMARY = gql`
  query GetCodeSecuritySummary {
    getCodeSecuritySummary {
      success
      message
      data {
        connected
        repos_in_scope
        branches_in_scope
        total_findings
        scored_findings
        check_status
        check_id
        check_type
        scored_levels
        last_scanned_at
      }
    }
  }
`;

export const GET_REPOS = gql`
  query GetRepos($in_scope: Boolean) {
    getRepos(in_scope: $in_scope) {
      success
      message
      data {
        id
        owner
        repo
        default_branch
        in_scope
        scope_reason
        branch_count
        in_scope_branch_count
        finding_count
        scored_finding_count
        status
        last_scanned_at
        level_counts {
          level
          count
        }
      }
    }
  }
`;

export const GET_BRANCHES = gql`
  query GetBranches($repo_data_id: ID!) {
    getBranches(repo_data_id: $repo_data_id) {
      success
      message
      data {
        id
        repo_data_id
        owner
        repo
        branch
        is_default_branch
        in_scope
        finding_count
        scored_finding_count
        status
        last_scanned_at
        level_counts {
          level
          count
        }
      }
    }
  }
`;

export const GET_CODE_SECURITY_FINDINGS = gql`
  query GetCodeSecurityFindings($branch_data_id: ID!) {
    getCodeSecurityFindings(branch_data_id: $branch_data_id) {
      success
      message
      data {
        id
        resource_id
        resource_name
        status
        status_reason
        detector_name
        level
        file_path
        line
        commit
        redacted_secret
        file_url
        provider
        created_at
      }
    }
  }
`;

export const SET_REPO_SCOPE = gql`
  mutation SetRepoScope(
    $repo_data_id: ID!
    $in_scope: Boolean!
    $scope_reason: String
  ) {
    setRepoScope(
      repo_data_id: $repo_data_id
      in_scope: $in_scope
      scope_reason: $scope_reason
    ) {
      success
      message
    }
  }
`;

export const SET_REPOS_SCOPE = gql`
  mutation SetReposScope(
    $repo_data_ids: [ID!]!
    $in_scope: Boolean!
    $scope_reason: String
  ) {
    setReposScope(
      repo_data_ids: $repo_data_ids
      in_scope: $in_scope
      scope_reason: $scope_reason
    ) {
      success
      message
    }
  }
`;

export const SET_BRANCH_SCOPE = gql`
  mutation SetBranchScope(
    $branch_data_id: ID!
    $in_scope: Boolean!
  ) {
    setBranchScope(
      branch_data_id: $branch_data_id
      in_scope: $in_scope
    ) {
      success
      message
    }
  }
`;

export const SET_BRANCHES_SCOPE = gql`
  mutation SetBranchesScope($branch_data_ids: [ID!]!, $in_scope: Boolean!) {
    setBranchesScope(branch_data_ids: $branch_data_ids, in_scope: $in_scope) {
      success
      message
    }
  }
`;

export const SET_CODE_SECURITY_SCORED_LEVELS = gql`
  mutation SetCodeSecurityScoredLevels(
    $input: SetCodeSecurityScoredLevelsInput!
  ) {
    setCodeSecurityScoredLevels(input: $input) {
      success
      message
    }
  }
`;

export const TRIGGER_CODE_SECURITY_SCAN = gql`
  mutation TriggerCodeSecurityScan {
    triggerCodeSecurityScan {
      success
      message
    }
  }
`;

export const GENERATE_CODE_SECURITY_EXCEL = gql`
  mutation GenerateCodeSecurityExcel {
    generateCodeSecurityExcel {
      url
    }
  }
`;
